import React, { useState } from 'react'
import Consulta from './Types/consulta'
import Cadastro from './Types/cadastro'
import TabNavigation from '../General/TabNavigation'
import Historico from './Types/historico'
import Estoque from './Types/estoque'

const Clientes = () => {
  const [activeTab, setActiveTab] = useState('consulta')

  // Função para ser passada ao Cadastro
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  const tabs = [
    {
      key: 'consulta',
      label: 'Consulta',
      icon: 'folder',
      content: <Consulta />
    },
    {
      key: 'cadastro',
      label: 'Cadastro',
      icon: 'config',
      content: <Cadastro onTabChange={handleTabChange} />
    },
    {
      key: 'estoque',
      label: 'Estoque',
      icon: 'chart',
      content: <Estoque />
    },
    {
      key: 'historico',
      label: 'Histórico',
      icon: 'chart',
      content: <Historico />
    }
  ]

  return (
    <div className='w-full min-h-full'>
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="default"
      />
    </div>
  )
}

export default Clientes;
